/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportParameters } from './ReportParameters';
export type CreateReportRequestDto = {
  /**
   * Report Type
   */
  type: CreateReportRequestDto.type;
  /**
   * Export file format
   */
  format: CreateReportRequestDto.format;
  parameters: ReportParameters;
};
export namespace CreateReportRequestDto {
  /**
   * Report Type
   */
  export enum type {
    DEVICE_TELEMETRY = 'DEVICE_TELEMETRY',
  }
  /**
   * Export file format
   */
  export enum format {
    CSV = 'CSV',
    XLSX = 'XLSX',
  }
}

